import React from 'react';
import { Mail, Globe, Clock } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Container } from '../components/ui';
import Reveal from '../components/Reveal';
import LeadForm from '../components/LeadForm';

export default function Contact() {
  const { t } = useLanguage();
  const items = [
    { icon: Mail, label: 'Email', value: 'info@billportal.io' },
    { icon: Globe, label: 'Data residency', value: 'US · UK · AU' },
    { icon: Clock, label: 'Response', value: 'Within 1 business day' },
  ];
  return (
    <section className="relative overflow-hidden px-5 py-16 sm:px-8 sm:py-20">
      <div className="bp-grid-bg pointer-events-none absolute inset-0 opacity-30" />
      <Container className="relative">
        <div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-2">
          <Reveal>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-brand"><span className="h-1.5 w-1.5 rounded-full bg-brand" /> {t('nav.contact')}</span>
            <h1 className="mt-4 font-display text-3xl font-extrabold leading-tight text-slate-900 dark:text-white sm:text-4xl">Let’s talk about your utility data</h1>
            <p className="mt-4 max-w-lg text-base leading-relaxed text-slate-600 dark:text-slate-300">Questions about the platform, a partnership, or pricing? Send us a note and the right person will get back to you.</p>
            <div className="mt-8 space-y-4">
              {items.map((it) => (
                <div key={it.label} className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand/10 text-brand"><it.icon className="h-5 w-5" /></span>
                  <div>
                    <div className="text-xs text-slate-400 dark:text-slate-500">{it.label}</div>
                    <div className="text-sm font-semibold text-slate-900 dark:text-white">{it.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={80}>
            <LeadForm source="contact" submitLabel={t('form.submitContact')} />
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
